import React from 'react'
import { SVGProps } from 'react'

const GarageIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8 1 1 4.8V15h2.2V8.2A.8.8 0 0 1 4 7.4h8a.8.8 0 0 1 .8.8V15H15V4.8L8 1Z" />
    <path d="M4.4 8.8h7.2v1.4H4.4V8.8Zm0 2.4h7.2v1.4H4.4v-1.4Zm0 2.4h7.2V15H4.4v-1.4Z" />
  </svg>
)
export default GarageIcon
